import { Tooltip } from "antd";
import { FilledTrashIcon } from "../../shared/Icons/FilledTrashIcon";
import { Container } from "./style";

interface IProps {
  onDelete: () => void;
  style?: React.CSSProperties;
  disabled?: boolean;
  tooltip?: string;
}

export const DeleteButton = ({ onDelete, style, disabled=false, tooltip }: IProps) => {
  return (
    <Tooltip title={tooltip} placement="bottom">
      <Container disabled={disabled} style={style} onClick={disabled ? undefined : onDelete}>
        <FilledTrashIcon  width={14} height={18} />
      </Container>
    </Tooltip>
  );
}